import { render, staticRenderFns } from "./PropertyTree.vue?vue&type=template&id=bf0c9fb8&"
import script from "./PropertyTree.vue?vue&type=script&lang=js&"
export * from "./PropertyTree.vue?vue&type=script&lang=js&"
import style0 from "./PropertyTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
